import { useEffect, useRef, useState } from 'react';

type UseMountedRefResult<T> = {
  parentRef: React.RefObject<T | null>;
  isParentReady: boolean;
};

/**
 * This hook is used to check if the parentRef is ready.
 * @returns {UseMountedRefResult} Returns the parentRef and isParentReady.
 */
function useMountedRef<T extends HTMLElement>(): UseMountedRefResult<T> {
  const parentRef = useRef<T>(null);
  const [isParentReady, setIsParentReady] = useState(false);

  useEffect(() => {
    if (parentRef.current) {
      setIsParentReady(true);
    }
  }, [parentRef]);

  return { parentRef, isParentReady };
}

export default useMountedRef;
